@if (contextMenuObject) {
  <div>
    <div class="d-flex space-children-mr justify-content-end" *dsRenderOnlyForBrowser="true">
      @for (entry of (menuStandaloneEntries$ | async); track entry) {
        <ng-container *ngComponentOutlet="entry; injector: objectInjector;"></ng-container>
      }
      <div ngbDropdown #itemOptions="ngbDropdown" placement="bottom-right"
        class="float-end ms-1" [ngClass]="optionCount === 0 ? 'd-none' : 'd-inline-block'">
        <button class="btn btn-outline-primary" id="context-menu" ngbDropdownToggle>
          <i class="fas fa-ellipsis-h" aria-hidden="true"></i>
        </button>
        <div id="itemOptionsDropdownMenu" aria-labelledby="context-menu" ngbDropdownMenu>
          <h6 class="dropdown-header">{{'context-menu.actions.label' | translate}}</h6>
          @for (entry of (menuEntries$ | async); track entry) {
            <ng-container *ngComponentOutlet="entry; injector: objectInjector;"></ng-container>
          }
        </div>
      </div>
    </div>
  </div>
}
